import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/query/react";
import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import { UpdateUserRequest } from "api/types/requests";
import { QueryTags } from "api/types/QueryTags";
import User from "api/types/models/user";

const userEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      {},
      FetchBaseQueryMeta
    >,
    QueryTags,
    "data"
  >,
) => ({
  updateUser: builder.mutation<User, { id: number; body: UpdateUserRequest }>({
    query: ({ id, body }) => ({
      url: `/users/${id}`,
      method: "put",
      body,
    }),
    invalidatesTags: ["User"],
  }),
});

export default userEndpoints;
